import axios from 'axios';
import { useCallback, useState } from 'react';

import AuthModule from '../auth/AuthModule';
import { ContractDocumentRequest } from './types/contractDocumentRequest';

export const useContractDocument = () => {
  // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars
  const [res, _] = useState({ data: null, error: null, isLoading: false });

  const callAPI = useCallback(
    async (
      contractDocumentRequest: ContractDocumentRequest,
      contractNumber: string,
      contractPosition: string,
    ) => {
      try {
        const b2cToken =
          await AuthModule.getInstance().getProfileTokenRedirect();
        const resTemp = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_API_URL}/contract/contractdocument/${contractNumber}/${contractPosition}/${contractDocumentRequest?.archiveId}/${contractDocumentRequest?.documentType}/${contractDocumentRequest?.archiveDocId}`,
          headers: {
            Authorization: `Bearer ${b2cToken}`,
            'Ocp-Apim-Subscription-Key': `${process.env.REACT_APP_API_KEY}`,
          },
        });
        return {
          data: resTemp.data.rvBase64Pdf,
          error: null,
          isLoading: false,
        };
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        return {
          data: null,
          error,
          isLoading: false,
        };
      }
    },
    [],
  );
  return { res, callAPI };
};
